module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Fahrwangen-b29ce8bed476baa1a749b3fbd562356d.svg";